import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export class RequestCompleted extends Component {

    startNewRequest = () => {
        if (this.props.onStartNewRequest) {
            this.props.onStartNewRequest();
        }
    }

    render() {
        return (
            <div className="request-container">
                <div className="request-completed" >
                    
                <h5>Request Submitted</h5>
                <span className="request-container-header">
                    Thank you for submitting your data request. You will be notified by email when your request is received.
                </span>

                <button
                    onClick={this.startNewRequest}>
                    Begin a new request ...
                </button>
                
                </div>
            </div>
        )
    }
}

export default RequestCompleted
